import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { BuyerDashboardComponent } from './main/dashboard/buyer/buyer-dashboard.component';
import { SellerDashboardComponent } from './main/dashboard/seller/seller-dashboard.component';
import { AuthInterceptor } from './_helpers/auth.interceptor';
import { AuthService } from './auth/services/auth.service';
import { SharedService } from './shared/serviceLayer/shared.service';
import { UserService } from './views/users/services/user.service';
import { ViewsComponent } from './views/views.component';
import { AuthGuard } from './_helpers/auth.guard.service';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { SessionService } from './shared/serviceLayer/session.service';
import { MatSelectModule } from '@angular/material/select';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from "src/environments/environment";
import { AppDashboardComponent } from './app-dashboard/app-dashboard.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';
import { BidStockService } from './main/auction-join/services/bid-stock.service ';
import { AuctionStockService } from './main/auction-join/services/auction-stock.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { YoutubeBannerComponent } from './main/youtube-banner/youtube-banner.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { YoutubeCardsComponent } from './main/youtube-banner/youtube-cards/youtube-cards.component';
import { PageNotFoundComponent } from './main/404not-found/page-not-found/page-not-found.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatDialogModule } from '@angular/material/dialog';
import { NgHttpLoaderComponent, pendingRequestsInterceptor$ } from 'ng-http-loader';
import { provideTranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

const config: SocketIoConfig = { url: environment.SOCKET_URL, options: {} };

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ViewsComponent,
    EditProfileComponent,
    AppDashboardComponent,
    VehicleDetailsComponent,
    YoutubeBannerComponent,
    YoutubeCardsComponent,
    BuyerDashboardComponent,
    SellerDashboardComponent,
  ],
  imports: [
    MatDialogModule,
    MatExpansionModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    // NgHttpLoaderComponent,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AuthModule,
    SharedModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    FormsModule,
    TooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    CarouselModule,
    LazyLoadImageModule,
    SocketIoModule.forRoot(config),
    TranslateDirective,
    TranslatePipe,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([pendingRequestsInterceptor$]),
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ...provideTranslateService({
      loader: provideTranslateHttpLoader({ suffix: `.json?v=${environment.i18nVersion}` })
    }),
    provideClientHydration(),
    AuthGuard,
    AuthService,
    SharedService,
    UserService,
    SessionService,
    BidStockService,
    AuctionStockService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


